import { ApiResponse, TokenData, IInteriorColor } from '../models';
import * as http from './http';
import ApiService from './service';

export class InteriorColorService extends ApiService {
  public async loadAllInteriorColors(): Promise<IInteriorColor[]> {
    const url = `${this.apiDomain}/api/trade-in/interior-color`;

    const resposne = await http.get<ApiResponse<IInteriorColor[]>>(
      url,
      this.store
    );
    return resposne?.data?.data;
  }

  public async updateInteriorColor(data: IInteriorColor, id?: string) {
    const url = `${this.apiDomain}/api/trade-in/interior-color/${id}`;

    const response = await http.put<ApiResponse<IInteriorColor>>(
      url,
      data,
      this.store
    );
    return response.data;
  }

  public async createInteriorColor(data: IInteriorColor) {
    const url = `${this.apiDomain}/api/trade-in/interior-color`;

    const response = await http.post<ApiResponse<IInteriorColor>>(
      url,
      data,
      this.store
    );
    return response.data;
  }

  public async deleteInteriorColor(id?: string) {
    const url = `${this.apiDomain}/api/trade-in/interior-color/${id}`;

    const response = await http.remove<ApiResponse<IInteriorColor>>(
      url,
      this.store
    );
    return response.data;
  }
}
